import MuiCircularProgress from '@material-ui/core/CircularProgress';

export default MuiCircularProgress;
